module.exports = __webpack_public_path__ + "static/img/k24_kt_04.9afcc42a.png";